export default __webpack_public_path__ + "static/media/chuniao.df79c7a2.png";